import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {eventTag, getCurrentCNPJ, validateLinkVideo} from "../../services/utils";
import moment from "moment/moment";
import ApiCMS from "../../services/cms";
import Loading from "../../components/loading";
import Breadcrumb from "../../components/breadcrumb";
import "./index.scss";
import { AppContext } from "../../context/app";
import { Link } from "react-router-dom";
import { BaSeIcon, BaSeParagraph } from "@base/react";

const ApiPill = ApiCMS();

const event = {
  name: "pill",
  category: "pilula",
  action: "click",
}

const PillContent = () => {
  const { companies } = useContext(AppContext);
  const { id } = useParams();
  const [pill, setPill] = useState(null);
  const [loading, setLoading] = useState(false);
  const breadcrumb = [
    { label: "Início", href: "/inicio" },
    { label: "Pílulas de Conhecimento", href: "/pilulas" },
    { label: pill?.title || "" },
  ];

  const getPill = () => {
    setLoading(true);
    ApiPill.getPillById(id, getCurrentCNPJ(companies))
      .then((response) => {
        const { data } = response;
        setPill(data);
      })
      .catch((error) => {
        console.warn("ERROR: ", error);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    getPill();
  }, [id, getCurrentCNPJ(companies)]);

  return (
    <div className="wrapper-pill-internal">
      {loading ? (
        <Loading fullPage />
      ) : (
        <div className="container">
          <div className="pill-header">
            <div className="breadcrumb-area">
              <Breadcrumb items={breadcrumb} />
            </div>
            <h1>{pill?.title || ""}</h1>
            <p>
              Autor:{" "}
              {pill?.modified_by ? pill.modified_by : "Sebrae"}{" "}
              | Data: {moment(pill?.created_at).format("DD/MM/YYYY")}
            </p>
          </div>
          <div className="content">
            {pill?.image ? (
              <div className="media image">
                <img src={pill?.image} alt={pill?.title || "Imagem"} />
              </div>
            ) : (
              ""
            )}
            <div
              className="text"
              dangerouslySetInnerHTML={{ __html: pill?.body }}
            ></div>
            <div className="clear"></div>
            {pill?.video ? (
              <div className="media video">
                <iframe
                  src={validateLinkVideo(pill?.video)}
                  width="100%"
                  height="100%"
                  allow="accelerometer autoplay clipboard-write encrypted-media gyroscope picture-in-picture"
                  allowFullScreen
                  title={pill?.title || "Video"}
                />
              </div>
            ) : (
              ""
            )}
          </div>
          <div className="previousAndNextPage">
            <Link
              to={pill?.has_previous ? `/pilula/${pill.has_previous}` : ""}
              className={!pill?.has_previous ? "pill-disabled" : ""}
              onClick={() => eventTag(event?.name, event?.category, event?.action, "Conteúdo anterior")}
            >
              <BaSeIcon
                name="angle-left"
                color={!pill?.has_previous ? "#808080" : "#2E5DE6"}
                description="Icon"
                size={15}
              />
              <BaSeParagraph
                color={!pill?.has_previous ? "#808080" : "#2E5DE6"}
                isBold
              >
                Conteúdo anterior
              </BaSeParagraph>
            </Link>
            <Link
              to={pill?.has_next ? `/pilula/${pill.has_next}` : ""}
              className={!pill?.has_next ? "pill-disabled" : ""}
              onClick={() => eventTag(event?.name, event?.category, event?.action, "Próximo conteúdo")}
            >
              <BaSeParagraph
                color={!pill?.has_next ? "#808080" : "#2E5DE6"}
                isBold
              >
                Próximo conteúdo
              </BaSeParagraph>{" "}
              <BaSeIcon
                name="angle-right"
                color={!pill?.has_next ? "#808080" : "#2E5DE6"}
                description="Icon"
                size={15}
              />
            </Link>
          </div>
        </div>
      )}
    </div>
  );
};

export default PillContent;
